import React from 'react'
import styled from 'styled-components'
import media from './theme-media.js'
import {useHeaderContext} from './header.js' 
import theme from './theme.js'
import Item from './header-menu-main-mobile-item.js'
import Social from './header-nav-social.js'

const UnstyledMobileMainMenu = ({
  className
}) => {
  const header = useHeaderContext()
  const isOpen = header.mobileMenuIsOpen

  const props = {
    className,
    isOpen
  }

  const items = header.menu.items.map(entry => {
    const props = {
      entry,
      key: entry.key
    }

    return <Item {...props}/>
  })

  return (
    <MobileMainMenu {...props}>
      <MenuItems>
        {items}
      </MenuItems>
      <SocialBar/>
    </MobileMainMenu>
  )
}

const MobileMainMenu = styled.div`  
  width: 35rem;
  height: 100%;
  position: fixed;
  right: 0;
  top: 0;
  background: ${theme.color.grey.medium};
  z-index: 100;
  display: ${props => props.isOpen ? 'block' : 'none'};

  ${media.aboveTablet`
    display: none;
  `}
`

const MenuItems = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const SocialBar = styled(Social)`
  position: absolute;
  bottom: 0;
  z-index: 200;
  display: flex !important;
  justify-content: center;
  width: 100%;
  padding: 1em;
  background: rgba(0,0,0,.1);
  
  &:before {
    display: none !important;
  }
`

export default UnstyledMobileMainMenu